(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedelia-customer-care"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seedelia-customer-care')) {
    customElements.define('seedelia-customer-care', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const tabs = [...this.querySelectorAll('[data-care-tab]')];
        const panels = [...this.querySelectorAll('[data-care-panel]')];
        const activate = tab => {
          tabs.forEach(item => { item.setAttribute('aria-selected', String(item === tab)); item.tabIndex = item === tab ? 0 : -1; });
          panels.forEach(panel => { panel.hidden = panel.dataset.carePanel !== tab.dataset.careTab; });
        };
        tabs.forEach((tab,index) => {
          tab.addEventListener('click', () => activate(tab), { signal });
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs[tabs.length-1] : tabs[(index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
            activate(next); next.focus();
          }, { signal });
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedelia-customer-stats"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seedelia-customer-stats')) {
    customElements.define('seedelia-customer-stats', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.countComplete || this.observer) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motion.matches || !('IntersectionObserver' in window)) return;
        this.counters = [...this.querySelectorAll('[data-count-value]')].map(node => {
          const original = node.textContent.trim();
          const match = original.match(/^(\d[\d,]*(?:\.\d+)?)(.*)$/);
          if (!match) return null;
          const decimals = (match[1].split('.')[1] || '').length;
          const format = new Intl.NumberFormat('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
          return { node, original, target: Number(match[1].replaceAll(',', '')), suffix: match[2], format };
        }).filter(Boolean);
        this.counters.forEach(counter => { counter.node.textContent = counter.format.format(0) + counter.suffix; });
        this.observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.dataset.countComplete = 'true';
          if (this.motion.matches) { this.finish(); return; }
          const start = performance.now();
          const tick = now => {
            const progress = Math.min((now - start) / 1500, 1);
            const eased = 1 - Math.pow(1 - progress, 3);
            this.counters.forEach(counter => { counter.node.textContent = counter.format.format(counter.target * eased) + counter.suffix; });
            if (progress < 1 && !this.motion.matches) this.frame = requestAnimationFrame(tick);
            else this.finish();
          };
          this.frame = requestAnimationFrame(tick);
        }, { threshold: 0.15 });
        this.observer.observe(this.querySelector('.seedelia-customer-stats__grid'));
      }
      finish() { this.counters?.forEach(counter => { counter.node.textContent = counter.original; }); this.frame = null; }
      disconnectedCallback() { this.observer?.disconnect(); this.observer = null; if (this.frame) cancelAnimationFrame(this.frame); this.finish(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedelia-five-reasons"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seedelia-five-reasons')) {
    customElements.define('seedelia-five-reasons', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.seedelia-five-reasons__track');
        this.cards = [...this.querySelectorAll('.seedelia-five-reasons__card')];
        if (!this.track || !this.cards.length) return;
        this.prev = this.querySelector('[data-reason-prev]');
        this.next = this.querySelector('[data-reason-next]');
        this.status = this.querySelector('[role="status"]');
        this.controls = this.querySelector('.seedelia-five-reasons__controls');
        this.prev.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => this.update(), { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.seedelia-five-reasons__card');
          if (card) this.track.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'auto' });
        }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }
      get stride() {
        return this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
      }
      move(direction) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({ left: direction * this.stride, behavior: reducedMotion ? 'auto' : 'smooth' });
      }
      update() {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.controls.hidden = !overflow;
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
        const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
        const visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / this.stride + .05));
        const first = Math.min(this.cards.length - visible, Math.max(0, Math.round(this.track.scrollLeft / this.stride))) + 1;
        const last = Math.min(this.cards.length, first + visible - 1);
        this.status.textContent = `${first}${last > first ? `–${last}` : ''} / ${this.cards.length}`;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedelia-mobile-action"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seedelia-mobile-action')) {
    customElements.define('seedelia-mobile-action', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.offer = document.getElementById('seedelia-offer');
        const update = () => {
          this.frame = null;
          this.hidden = !this.offer || this.offer.getBoundingClientRect().bottom > 0;
        };
        const schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(update);
        };
        window.addEventListener('scroll', schedule, { passive: true, signal });
        document.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        window.addEventListener('pageshow', schedule, { signal });
        document.addEventListener('shopify:section:load', () => {
          this.offer = document.getElementById('seedelia-offer');
          schedule();
        }, { signal });
        if (this.offer) {
          this.observer = new ResizeObserver(schedule);
          this.observer.observe(this.offer);
        }
        this.querySelector('a').addEventListener('click', event => {
          const url = new URL(event.currentTarget.href, location.href);
          const target = url.hash === '#seedelia-offer' ? document.getElementById('seedelia-offer') : null;
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
          const selected = target.querySelector('input:checked');
          selected?.focus({ preventScroll: true });
        }, { signal });
        update();
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); if (this.frame) cancelAnimationFrame(this.frame); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seedelia-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seedelia-reviews')) {
    customElements.define('seedelia-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) this.controller.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.track = this.querySelector('.seedelia-reviews__track');
        this.track.querySelectorAll('[data-review-clone]').forEach(card => card.remove());
        this.cards = [...this.querySelectorAll('.seedelia-review-card')];
        this.cards.forEach(card => {
          const toggle = card.querySelector('[data-review-toggle]');
          if (!toggle) return;
          toggle.addEventListener('click', () => {
            const expanded = card.toggleAttribute('data-review-expanded');
            card.toggleAttribute('data-review-collapsed', !expanded);
            toggle.setAttribute('aria-expanded', String(expanded));
            toggle.textContent = expanded ? toggle.dataset.lessLabel : toggle.dataset.moreLabel;
            if (!expanded) this.updateQuotes();
            this.syncClones();
          }, { signal });
        });
        this.quoteResizeObserver = new ResizeObserver(() => this.updateQuotes());
        this.quoteResizeObserver.observe(this.track);
        this.updateQuotes();
        this.prev = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.status = this.querySelector('[data-review-status]');
        this.setAttribute('data-enhanced', '');
        if (this.dataset.layout === 'carousel') {
          this.querySelector('.seedelia-reviews__controls').hidden = this.cards.length < 2;
          this.prev.addEventListener('click', () => this.move(-1), { signal });
          this.next.addEventListener('click', () => this.move(1), { signal });
          this.track.addEventListener('scroll', () => {
            this.update();
            clearTimeout(this.settleTimer);
            this.settleTimer = setTimeout(() => this.normalizeLoop(), 180);
          }, { passive: true, signal });
          this.track.addEventListener('touchstart', () => { this.touching = true; }, { passive: true, signal });
          const release = () => { this.touching = false; clearTimeout(this.settleTimer); this.settleTimer = setTimeout(() => this.normalizeLoop(), 180); };
          this.track.addEventListener('touchend', release, { passive: true, signal });
          this.track.addEventListener('touchcancel', release, { passive: true, signal });
          this.track.addEventListener('scrollend', () => this.normalizeLoop(), { passive: true, signal });
          this.track.addEventListener('keydown', event => {
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
          }, { signal });
          this.resizeObserver = new ResizeObserver(() => this.configureLoop());
          this.resizeObserver.observe(this.track);
          this.configureLoop();
        } else {
          const button = this.querySelector('.seedelia-reviews__expand');
          button.hidden = this.cards.length <= 2;
          button.addEventListener('click', () => {
            const expanded = this.toggleAttribute('data-expanded');
            button.setAttribute('aria-expanded', String(expanded));
            button.textContent = expanded ? button.dataset.hideLabel : button.dataset.showLabel;
          }, { signal });
        }
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.seedelia-review-card');
          if (!card) return;
          if (this.dataset.layout === 'expand') {
            this.setAttribute('data-expanded', '');
            const button = this.querySelector('.seedelia-reviews__expand');
            button.setAttribute('aria-expanded', 'true'); button.textContent = button.dataset.hideLabel;
          } else this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'instant' });
        }, { signal });
      }
      updateQuotes() {
        this.cards.forEach(card => {
          const quote = card.querySelector('.seedelia-review-card__quote');
          const toggle = card.querySelector('[data-review-toggle]');
          if (!quote || !toggle || card.hasAttribute('data-review-expanded')) return;
          card.setAttribute('data-review-collapsed', '');
          const overflowing = quote.scrollHeight > quote.clientHeight + 1;
          card.toggleAttribute('data-review-collapsed', overflowing);
          toggle.hidden = !overflowing;
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = toggle.dataset.moreLabel;
        });
        this.syncClones();
      }
      syncClones() {
        this.track.querySelectorAll('[data-review-clone]').forEach(clone => {
          const original = this.cards[Number(clone.dataset.reviewClone)];
          for (const attr of ['data-review-expanded', 'data-review-collapsed']) clone.toggleAttribute(attr, original.hasAttribute(attr));
          const source = original.querySelector('[data-review-toggle]');
          const target = clone.querySelector('[data-review-toggle]');
          if (source && target) { target.hidden = source.hidden; target.textContent = source.textContent; }
        });
      }
      configureLoop() {
        const enabled = matchMedia('(max-width: 749px)').matches && this.cards.length > 1;
        const active = this.index || 0;
        if (enabled !== this.looping) {
          this.track.querySelectorAll('[data-review-clone]').forEach(card => card.remove());
          this.looping = enabled;
          if (enabled) {
            for (const side of ['before', 'after']) {
              const fragment = document.createDocumentFragment();
              this.cards.forEach((card, index) => {
                const clone = card.cloneNode(true);
                clone.dataset.reviewClone = index;
                clone.setAttribute('aria-hidden', 'true');
                clone.inert = true;
                [clone, ...clone.querySelectorAll('*')].forEach(element => {
                  element.removeAttribute('id');
                  element.removeAttribute('aria-controls');
                  element.removeAttribute('data-shopify-editor-block');
                });
                fragment.append(clone);
              });
              if (side === 'before') this.track.prepend(fragment); else this.track.append(fragment);
            }
            this.syncClones();
          }
        }
        const width = this.track.clientWidth;
        if (enabled && width !== this.loopWidth) this.jumpTo(this.cards[active]);
        this.loopWidth = width;
        this.update();
      }
      jumpTo(card) {
        this.track.style.scrollSnapType = 'none';
        this.track.scrollTo({ left: card.offsetLeft - this.track.firstElementChild.offsetLeft, behavior: 'instant' });
        cancelAnimationFrame(this.snapFrame);
        this.snapFrame = requestAnimationFrame(() => { this.track.style.scrollSnapType = ''; });
      }
      normalizeLoop() {
        if (!this.looping || this.touching) return;
        const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
        const position = Math.round(this.track.scrollLeft / step);
        const count = this.cards.length;
        if (position < count || position >= count * 2) this.jumpTo(this.cards[((position % count) + count) % count]);
        this.update();
      }
      update() {
        if (!this.cards.length) return;
        const width = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0);
        this.index = this.looping ? Math.round(this.track.scrollLeft / width) % this.cards.length : Math.min(this.cards.length - 1, Math.max(0, Math.round(this.track.scrollLeft / width)));
        this.prev.disabled = this.cards.length < 2;
        this.next.disabled = this.cards.length < 2;
        const label = `${this.index + 1} / ${this.cards.length}`;
        if (this.status.textContent !== label) this.status.textContent = label;
      }
      move(direction) {
        if (!this.looping) return;
        this.normalizeLoop();
        const children = [...this.track.children];
        const current = this.cards.length + this.index;
        const target = children[current + direction].offsetLeft - children[0].offsetLeft;
        this.track.scrollTo({ left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() { this.controller?.abort(); this.resizeObserver?.disconnect(); this.quoteResizeObserver?.disconnect(); clearTimeout(this.settleTimer); cancelAnimationFrame(this.snapFrame); this.looping = false; this.loopWidth = null; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
